import React, {useContext, useState, useMemo, useEffect} from 'react';
import {
  Appbar,
  useTheme,
  TextInput,
  Searchbar,
} from 'react-native-paper';

import {Platform, View} from 'react-native';
import {useWindowDimensions} from 'react-native';
import {useAppSelector} from '../../store/hooks';
import uuid from 'react-native-uuid';

import {UserDataState} from '../../ctx';
import {
  CurrentUserData,
  Folder,
  FolderType,
  Media,
} from '../../types';
import {useMutation, useQuery, useQueryClient} from 'react-query';
import {
  encoderProjectTypes,
  extractMedia,
  getUserData,
  writeItem,
} from '../../api';

import {FolderParams} from '../../types/nav';

import {NativeStackHeaderProps} from '@react-navigation/native-stack';
import {BannerContainer} from './components/bannercontainer';
import {Actions} from './components/actions';

import {
  Audio,
  InterruptionModeAndroid,
  InterruptionModeIOS,
} from 'expo-av';

import {
  NavInput,
  addFolderPlaceholder,
  chatPlacehoder,
  defaulPlaceHolderText,
  searchContactsPlaceholderText,
} from './components/navinput';
export default function CustomNavigationBar({
  options,
}: NativeStackHeaderProps) {
  const theme = useTheme();
  const queryClient = useQueryClient();
  const [searchValue, setSearch] = useState('');
  const {width} = useWindowDimensions();
  const mode = useAppSelector(state => state.ui.editingMode);
  const userState = useContext(UserDataState) as CurrentUserData;
  const userData = useQuery('UserData', () => getUserData());
  const userId = userData?.data?.id;
  const [isLocked, setLocked] = useState(false);
  const writeItemMutation = useMutation(
    (item: Media | Folder) => writeItem(item),
    {retry: true},
  );
  useEffect(() => {
    const enableAudio = async () => {
      await Audio.setAudioModeAsync({
        allowsRecordingIOS: false,
        interruptionModeIOS: InterruptionModeIOS.DuckOthers,
        playsInSilentModeIOS: true,
        staysActiveInBackground: true,
        interruptionModeAndroid: InterruptionModeAndroid.DuckOthers,
        shouldDuckAndroid: false,
      });
    };
    enableAudio();
  }, []);
  const params = useAppSelector(state => state.ui.params);
  const folderType = useAppSelector(state => state.ui.folderType);

  const folderId =
    (params as FolderParams)?.folderId || params?.parentFolderId;

  const newFolderType = 'new_' + folderType;
  const isEncoderProject = encoderProjectTypes.includes(folderType);

  const extractLink = async () => {
    if (
      searchValue.search('http') === -1 &&
      searchValue.search('magnet') === -1
    )
      return;
    console.info(searchValue);

    if (isLocked === true) return;
    setLocked(true);
    setTimeout(() => {
      setLocked(false);
    }, 20000);

    let exData = await extractMedia(searchValue);
    if (exData && exData.id) {
      const {id} = exData;

      try {
        const nd: Media & {isFolder?: boolean} = {
          ...exData,
          originalId: id,
          id: uuid.v4().toString(),
          folderId: folderId || newFolderType,
          userId: userState.user.id,
          date: new Date().valueOf(),
          isMediaNew: true,
          isFolder:
            exData.files && exData.files.length ? true : undefined,
          files:
            exData.files &&
            exData.files.map((i: {name: string; length: number}) => ({
              name: i.name,
              size: i.length,
            })),
        };
        await writeItemMutation.mutateAsync(nd);
        await queryClient.refetchQueries({
          queryKey: 'folderContent_' + nd.folderId,
        });
        setSearch('');
      } catch (err) {
        console.error('extractLink', err);
      }
    }
    setLocked(false);
  };

  useMemo(() => {
    extractLink();
  }, [searchValue]);
  const showFullSearchBar = width > 700 && Platform.OS !== 'macos';

  let placeholderText = addFolderPlaceholder;

  if (mode === 'party') {
    placeholderText = chatPlacehoder;
  }
  if (mode === 'search') {
    placeholderText = 'type to search';
  }
  console.info('appnav refresh');
  return (
    <View style={{display: 'flex', flexDirection: 'column'}}>
      <Appbar.Header style={{zIndex: 1000}} theme={theme}>
        <NavInput
          options={options}
          folderId={folderId as string}
          isLocked={isLocked}
          searchValue={searchValue}
          setSearch={setSearch}
        />
        <Actions
          showFullSearchBar={showFullSearchBar}
          isEncoderProject={isEncoderProject}
          userId={userId}
        />
        {showFullSearchBar ? (
          <Searchbar
            loading={isLocked}
            mode="bar"
            placeholder={
              folderType === FolderType.contact
                ? searchContactsPlaceholderText
                : defaulPlaceHolderText
            }
            theme={theme}
            style={{height: 40, width: 300}}
            inputStyle={{paddingBottom: 14}}
            value={searchValue}
            onChangeText={setSearch}
          />
        ) : null}
      </Appbar.Header>
      <BannerContainer
        userId={userId}
        isEncoderProject={isEncoderProject}
        width={width}
      />
    </View>
  );
}
